import FaqQuestions from './FaqQuestions';

export default FaqQuestions;
